import React from 'react';
import "../App.css";
import './HomeHeroSection.css';
import {Button} from "./Button";
import video from "../assets/videos/video-2.mp4"

function HomeHeroSection() {
	return (
		<div className="home-hero-container">
			<video src={video} autoPlay loop muted />
			<h1>Informační technologie</h1>
			<p>Konzultace | Servis | Vývoj | Prodej</p>
			<div className="hero-btns">
				<Button
					className="btns"
					buttonStyle="btn--outline"
					buttonSize="btn--large"
				>Kontakt</Button>
			</div>

		</div>

	);
}

export default HomeHeroSection;